import Crud from '../views/Local/Crud'
import Entity from '../views/Local/Add'
import View from '../views/Local/View'

let routes = {
    path: '/locais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/locais/add',
            name: 'NewLocal',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Local',
                breadcrumb: [
                    {
                        text: 'Locais',
                        active: false,
                        to: '/locais',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/locais/edit/:id?',
            name: 'EditLocal',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Local',
                breadcrumb: [
                    {
                        text: 'Locais',
                        active: false,
                        to: '/locais',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/locais/view/:id?',
            name: 'ViewLocal',
            component: View,
            meta: {
                pageTitle: 'Visualizar Local',
                breadcrumb: [
                    {
                        text: 'Locais',
                        active: false,
                        to: '/locais',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/locais',
            name: 'list-locais',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Locais',
                breadcrumb: [
                    {
                        text: 'Locais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
